import { render, staticRenderFns } from "./warranty_preferences.vue?vue&type=template&id=6b2f0378&scoped=true&"
import script from "./warranty_preferences.vue?vue&type=script&lang=js&"
export * from "./warranty_preferences.vue?vue&type=script&lang=js&"
import style0 from "./warranty_preferences.vue?vue&type=style&index=0&id=6b2f0378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f0378",
  null
  
)

export default component.exports